import type { Component } from 'vue';
import { createTemplatePromise } from '@vueuse/core';

export type SheetProps = {
    title: string;
    class?: string;
} & (
    | {
          content: string;
          component?: undefined;
          props?: undefined;
      }
    | {
          content?: undefined;
          component: Component;
          props?: object;
      }
);

const SheetTemplate = createTemplatePromise<boolean, [SheetProps]>();

export default function useSheet() {
    return SheetTemplate;
}
